import { KYMW1406Component } from './kymw1406.component';
import { PlessViewUtilsSub } from '../../..//commons/kymw00/pless-view-utils-sub.service';
import { GetCrossMultiResponse } from './api-services/get-cross-multi.service';

/**
 * 商品情報画面の値を管理するクラス
 *
 * @export KYMW1406Model
 * @class KYMW1406Model
 */
export class KYMW1406Model {

  kymw1406Component: KYMW1406Component;

  // 検索結果
  /**
   * 「商品一覧」のリスト情報を保持する
   */
  public goodsInfoList: Array<any> = null;

  /**
   * 「商品一覧」で選択した商品の詳細情報を保持する
   */
  public goodsDetailList: Array<any> = null;

  /**
   * 「表組パターン」の選択行を保持する
   */
  public selectedListingPatternIndex = Number(-1);

  /**
   * 「表組用商品名」の選択候補を保持する
   */
  public listingGoodsNameList: Array<any> = null;

  /**
   * コマＩＤ
   */
  public komaID = Number(0);

  /**
   * 編集状態
   */
  public editMode = String('');

  /**
   * 表組情報
   */
  public listingInfoList: Array<any> = new Array<any>();

  /**
   * コマ情報
   */
  public komaInfoList: Array<any> = new Array<any>();

  /**
   * 更新フラグ(0:デフォルト、1:更新、2:削除、3:商品情報変更)
   * コマ割り画面での更新後の子画面再表示で使用
   */
  public updateFlg = Number(0);

  /**
   * 注文商品区分(01：通常注文商品　02:いつでも注文商品)
   */
  public orderGoodsFlg = String('');

  // 表組用商品名コンボボックス選択値
  public listingGoodsName = String('');

  // コマコメント
  public komaComment = String('');

  // 価値コマコメント
  public valueKomaComment = '';

  /**
  * クロス設定情報
  */
  public crossSetting = {
    crossCode: '',
    goodsExplanation: '',
    catchCopy: ''
  };

  /**
  * マルチ設定情報
  */
  public multiSetting = {
    multiCode: '',
    goodsExplanation: '',
    catchCopy: ''
  };

  public disabledRegist = Boolean(false);
  public disabledGoodsInfo = Boolean(false);
  public disabledKomaComment = Boolean(false);
  public disabledKomaPatternDiv = Boolean(false);
  public disabledValueKomaComment = false;
  public disabledListingPatternID = Boolean(false);
  public disabledListingGoodsName = Boolean(false);
  public disabledCrossGoodsExplanation = false;
  public disabledCrossCatchCopy = false;
  public disabledMultiGoodsExplanation = false;
  public disabledMultiCatchCopy = false;


  /**
   * nullを0バイト文字列に変換する
   *
   * @private
   * @param {string} text 対象文字列
   * @returns {string}
   * @memberof KYMW1406Model
   */
  private editNull(text: string): string {
    let edit: string = text;
    if (edit == null || edit === 'null') {
      edit = '';
    }
    return edit;
  }

  /**
   * サーバ取得データを反映する
   *
   * @param {*} serverData サーバ取得データ
   * @memberof KYMW1406Model
   */
  public updateServerResponse(serverData: any): void {
    // 作業用変数定義
    const goodsList: Array<any> = new Array<any>();
    const listingInfo: Array<any> = new Array<any>();
    const komaList: Array<any> = new Array<any>();

    // 表組用商品名コンボボックス作成(先頭は空白行)
    const listingList: Array<any> = new Array<any>();
    const code = String('');
    const name = String('');
    listingList.push({ code: code, name: name });

    let serverDataObj: any = new Object();

    // 検索結果の格納を行う
    if (serverData != null) {
      // 検索結果が複数存在する場合は、ループしてすべてのデータを設定する
      if (serverData.GoodsInfo.Record != null) {
        // GoodsInfoタグ配下
        for (let i = Number(0); i < serverData.GoodsInfo.Record.length; i++) {
          // 表示編集
          serverDataObj = new Object();
          serverDataObj.OrderNumSeqNo = PlessViewUtilsSub.zeroPadding(3, serverData.GoodsInfo.Record[i].OrderNumSeqNo);
          serverDataObj.PCode = this.editNull(serverData.GoodsInfo.Record[i].PCode);
          serverDataObj.ItemCode = this.editNull(serverData.GoodsInfo.Record[i].ItemCode);
          serverDataObj.GuideGoodsName = this.editNull(serverData.GoodsInfo.Record[i].GuideGoodsName);
          serverDataObj.GuideStandardName = this.editNull(serverData.GoodsInfo.Record[i].GuideStandardName);
          serverDataObj.ThisTimeSupplyPrice =
            PlessViewUtilsSub.editPriceComma(serverData.GoodsInfo.Record[i].ThisTimeSupplyPrice, true);
          serverDataObj.OrderNum = this.editNull(serverData.GoodsInfo.Record[i].OrderNum);
          serverDataObj.ListingGoodsName = this.editNull(serverData.GoodsInfo.Record[i].ListingGoodsName);
          serverDataObj.BuyerComment = this.editNull(serverData.GoodsInfo.Record[i].BuyerComment);
          serverDataObj.GoodsExplanation = this.editNull(serverData.GoodsInfo.Record[i].GoodsExplanation);
          serverDataObj.CatchCopy = this.editNull(serverData.GoodsInfo.Record[i].CatchCopy);
          serverDataObj.RecommendComment = this.editNull(serverData.GoodsInfo.Record[i].RecommendComment);
          serverDataObj.ConvenienceInfoSiege = this.editNull(serverData.GoodsInfo.Record[i].ConvenienceInfoSiege);
          serverDataObj.ConvenienceInfoGoods = this.editNull(serverData.GoodsInfo.Record[i].ConvenienceInfoGoods);
          serverDataObj.ConvenienceInfoOther = this.editNull(serverData.GoodsInfo.Record[i].ConvenienceInfoOther);
          serverDataObj.ConvenienceInfoEFriend = this.editNull(serverData.GoodsInfo.Record[i].ConvenienceInfoEFriend);
          serverDataObj.ConvenienceInfoSize = this.editNull(serverData.GoodsInfo.Record[i].ConvenienceInfoSize);
          serverDataObj.HandleWithCare = this.editNull(serverData.GoodsInfo.Record[i].HandleWithCare);
          serverDataObj.AgeInformation = this.editNull(serverData.GoodsInfo.Record[i].AgeInformation);
          serverDataObj.PopularProductInformation = this.editNull(serverData.GoodsInfo.Record[i].PopularProductInformation);
          serverDataObj.HealthCareInformation = this.editNull(serverData.GoodsInfo.Record[i].HealthCareInformation);
          serverDataObj.IngredientInformation = this.editNull(serverData.GoodsInfo.Record[i].IngredientInformation);
          serverDataObj.WaterAbsorption = this.editNull(serverData.GoodsInfo.Record[i].WaterAbsorption);
          serverDataObj.MealKitEstimatedCookingTime = this.editNull(serverData.GoodsInfo.Record[i].MealKitEstimatedCookingTime);
          serverDataObj.MealKitPortionInformation = this.editNull(serverData.GoodsInfo.Record[i].MealKitPortionInformation);
          serverDataObj.MealKitIngredients = this.editNull(serverData.GoodsInfo.Record[i].MealKitIngredients);
          serverDataObj.MealKitItemsPreparedHome = this.editNull(serverData.GoodsInfo.Record[i].MealKitItemsPreparedHome);

          // 作業用配列に追加
          goodsList.push(serverDataObj);
          listingList.push({ code: serverDataObj.PCode, name: serverDataObj.ListingGoodsName });
        }
      }

      if (serverData.ListingInfo != null) {
        // ListingInfoタグ配下
        // XMLの生成
        serverDataObj = new Object();
        serverDataObj.ListingPatternID = PlessViewUtilsSub.nullToBlank(serverData.ListingInfo.ListingPatternID);
        serverDataObj.ListingPCode = PlessViewUtilsSub.nullToBlank(serverData.ListingInfo.ListingPCode);

        // 作業用配列に追加
        listingInfo.push(serverDataObj);
      }

      if (serverData.KomaInfo != null) {
        // KomaInfoタグ配下
        // XMLの生成
        serverDataObj = new Object();
        serverDataObj.KomaComment = PlessViewUtilsSub.nullToBlank(serverData.KomaInfo.KomaComment);
        serverDataObj.KomaPatternDiv = PlessViewUtilsSub.nullToBlank(serverData.KomaInfo.KomaPatternDiv);
        serverDataObj.ValueKomaComment = PlessViewUtilsSub.nullToBlank(serverData.KomaInfo.ValueKomaComment);

        // 作業用配列に追加
        komaList.push(serverDataObj);
      }
      if (serverData.CrossMultiInfo != null) {
        const cross = serverData.CrossMultiInfo.CrossInfo;
        this.crossSetting = {
          crossCode: PlessViewUtilsSub.nullToBlank(cross.CrossCode),
          goodsExplanation: PlessViewUtilsSub.nullToBlank(cross.GoodsExplanation),
          catchCopy: PlessViewUtilsSub.nullToBlank(cross.CatchCopy)
        };

        const multi = serverData.CrossMultiInfo.MultiInfo;
        this.multiSetting = {
          multiCode: PlessViewUtilsSub.nullToBlank(multi.MultiCode),
          goodsExplanation: PlessViewUtilsSub.nullToBlank(multi.GoodsExplanation),
          catchCopy: PlessViewUtilsSub.nullToBlank(multi.CatchCopy)
        };
      }
    }
    // 作業用配列を現在の配列に書き換え
    this.goodsInfoList = goodsList;
    this.listingGoodsNameList = listingList;
    this.listingInfoList = listingInfo;
    this.komaInfoList = komaList;

    // コマコメントがnullの場合空白を入れる。
    if (komaList[0].KomaComment != null) {
      this.komaComment = komaList[0].KomaComment;
    } else {
      this.komaComment = '';
    }
    // 画面に表示する価値コマコメントの値を設定する
    this.valueKomaComment = komaList[0]?.ValueKomaComment ?? '';

    // 初期表示設定
    if (this.goodsInfoList.length > 0) {
      this.kymw1406Component.showGoodsAttribute(0);
    }

    // コンボボックス初期表示
    this.kymw1406Component.showComboBox();
  }

  /**
   * 親画面に通知する
   *
   * @memberof KYMW1406Model
   */
  public refreshKYMW1400(): void {
    this.kymw1406Component.refreshKYMW1400();
  }

  public clearCrossAndMultiSetting() {
    this.clearCrossSetting();
    this.clearMultiSetting();
  }
  private clearCrossSetting() {
    this.crossSetting = {
      crossCode: '',
      goodsExplanation: '',
      catchCopy: ''
    };
  }
  private clearMultiSetting() {
    this.multiSetting = {
      multiCode: '',
      goodsExplanation: '',
      catchCopy: ''
    };
  }

  /**
   * GetCrossMultiResponseの値で、modelを更新する。
   */
  public updateCrossMulti(data: GetCrossMultiResponse) {
    const cross = data.CrossMultiInfo.CrossInfo;
    if (cross) {
      this.crossSetting = {
        crossCode: cross.CrossCode,
        goodsExplanation: cross.GoodsExplanation,
        catchCopy: cross.CatchCopy
      };
    } else {
      this.clearCrossSetting();
    }

    const multi = data.CrossMultiInfo.MultiInfo;
    if (multi) {
      this.multiSetting = {
        multiCode: multi.MultiCode,
        goodsExplanation: multi.GoodsExplanation,
        catchCopy: multi.CatchCopy
      };
    } else {
      this.clearMultiSetting();
    }
    // 「MultiInfo」が設定されていた場合は、マルチ設定用の「商品説明」と「キャッチコピー」を活性
    this.setDisabledMulti(!multi);
    // 行削除後の商品が2商品以上あり「MultiInfo」が未設定の場合は、クロス設定用の「商品説明」「キャッチコピー」を活性
    this.setDisabledCross(!(this.goodsInfoList.length >= 2 && !multi));
  }

  public setDisabledCross(isDisabled: boolean) {
    this.disabledCrossGoodsExplanation = isDisabled;
    this.disabledCrossCatchCopy = isDisabled;
  }
  public setDisabledMulti(isDisabled: boolean) {
    this.disabledMultiGoodsExplanation = isDisabled;
    this.disabledMultiCatchCopy = isDisabled;
  }
}
